import React, {useContext, useState} from 'react';
import { useTheme, Typography, makeStyles, Button, Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import globalContext from '../context/globalContext';
import ProgressButton from '../components/progressButton';
import Alert from '@material-ui/lab/Alert';
import API from '../global/api';
import CreditCardIcon from '@material-ui/icons/CreditCard';

const useStyles = makeStyles(theme => ({
    container: {},
    inner: {},
}));

const ServiceUtilityBillCurrentUsage = props => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const context = useContext(globalContext)

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    const handleSubmit = async () => {

        try {
            setLoading(true);
            setError(null);

            //
            // Execute an api request and get the returned result
            //
            API.req(`/service/bill_current/${context.profile.data.id_organisation}`, 'POST', {id_service: props.id_service}).then(
                async res => {

                    setLoading(false);
                    context.showSnack({message: 'Current service billing processing.'}, 'success')
                    handleClose();

                },
                err => {
                    setLoading(false);
                    setError(typeof err === 'string' ? err : JSON.stringify(err))
                }
            )
        
        } catch (err) {
            setLoading(false);
            setError(typeof err === 'string' ? err : JSON.stringify(err))
        } finally {
        }


    }

    const handleClose = () => {
        if(typeof props.handleClose === 'function')
            props.handleClose();
    }

    return (
        <Dialog onClose={handleClose} aria-labelledby="remove-rfid" open={true} maxWidth="xs">
            <DialogTitle id="remove-rfid-title"><Typography variant="h6" style={{display: 'flex', alignItems: 'center', flexDirection: 'row'}}><CreditCardIcon style={{marginRight: 10}} /> Bill current usage</Typography></DialogTitle>
            <DialogContent>
                {error && <Alert severity="error">{error}</Alert>}
                
                <Typography variant="body2">Confirm you wish to process the current usage on this session to the customer account?</Typography>
                <Typography variant="body2"><b>Note: This can take around 1 minute to process</b></Typography>
                
                <div className="flex-row space-between mt">
                    <Button onClick={handleClose}>Cancel</Button>
                    <ProgressButton waiting={loading} color="secondary" variant="contained" onClick={handleSubmit}>Confirm</ProgressButton>
                </div>
            </DialogContent>
        </Dialog>
    )
}
export default ServiceUtilityBillCurrentUsage;